import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Taxaterdag {
    constructor() {
        this.taxaterdagSlider();
    }

    taxaterdagSlider() {
        if (document.querySelector('.advantages')) {
            new Swiper('.advantages .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 50,
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        loop: false,
                    },

                },
            });
        }
    }
}
